import * as actions from "./bentukKerjasama.actions";
import * as types from "./bentukKerjasama.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { BentukKerjasamaReducerType } from "./types";

export type BentukKerjasamaActions = ActionType<typeof actions>;

export const initialState: BentukKerjasamaReducerType = {
  isLoading: false,
  errorMessage: '',
  redirectQueue: '',
  error: null,
  listBentukKerjasama: [],
  selectedBentukKerjasama: null,
};

export const BentukKerjasamaReducer = createReducer<
BentukKerjasamaReducerType,
  BentukKerjasamaActions
>(initialState)
  // GET BENTUK KERJASAMA
  .handleAction(actions.getBentukKerjasamaAsync.request, (state) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.getBentukKerjasamaAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    listBentukKerjasama: action.payload.data.items,
  }))
  .handleAction(actions.getBentukKerjasamaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // GET DETAIL BENTUK KERJASAMA
  .handleAction(actions.getDetailBentukKerjasamaAsync.request, (state) => ({
    ...state,
    isLoading: true,
    error: null,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.getDetailBentukKerjasamaAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    selectedBentukKerjasama: action.payload,
  }))
  .handleAction(actions.getDetailBentukKerjasamaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // UPDATE BENTUK KERJASAMA
  .handleAction(actions.updateBentukKerjasamaAsync.request, (state) => ({
    ...state,
    isLoading: true,
    error: null,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.updateBentukKerjasamaAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    redirectQueue: '/bentuk-kerjasama',
  }))
  .handleAction(actions.updateBentukKerjasamaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // CREATE BENTUK KERJASAMA
  .handleAction(actions.createBentukKerjasamaAsync.request, (state) => ({
    ...state,
    isLoading: true,
    error: null,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.createBentukKerjasamaAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    redirectQueue: '/bentuk-kerjasama',
  }))
  .handleAction(actions.createBentukKerjasamaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // OTHER SELECTORS
  .handleAction(types.INITIALIZE_CREATE_BENTUK_KERJASAMA as any, (state, action) => ({
    ...state,
    selectedBentukKerjasama: action.payload.bentukKerjasama,
  }))
  .handleAction(types.SELECT_BENTUK_KERJASAMA as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    selectedBentukKerjasama: action.payload.bentukKerjasama,
  }))
  .handleAction(types.UPDATE_NAME as any, (state, action) => ({
    ...state,
    selectedBentukKerjasama: (() => {
      if (state.selectedBentukKerjasama) {
        return {
          ...state.selectedBentukKerjasama,
          NAMA: action.payload.name
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_STATUS as any, (state, action) => ({
    ...state,
    selectedBentukKerjasama: (() => {
      if (state.selectedBentukKerjasama) {
        return {
          ...state.selectedBentukKerjasama,
          STATUS: action.payload.status
        };
      } else {
        return null;
      }
    })(),
  }))
